var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorPicker"},_vm._l((_vm.colors),function(color,i){return _c('div',{key:i,staticClass:"color",style:({'background-color' : color}),on:{"click":function($event){return _vm.selectColor(color)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }